<template>
    <div>
      <zj-layout-container v-loading="loading" element-loading-text="加载中...">
        <zj-layout-header>
          <div class="listtitle">{{ title }}</div>
          <el-form
            class="zj-search-form"
            ref="queryForm"
            :model="queryParams"
            :label-width="labelWidth"
          >
            <el-form-item label="用户名" prop="userName">
              <el-input
                v-model="queryParams.userName"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
  
            <!-- <el-form-item label="登录IP" prop="operationIp">
              <el-input
                v-model="queryParams.operationIp"
                placeholder="请输入IP"
              ></el-input>
            </el-form-item> -->
  
            <el-form-item label="统计时间段">
              <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 60rem"
                unlink-panels
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
  
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">重 置</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <el-table :data="operationLogList" border style="width: 100%" fixed>
                <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
                ></el-table-column>
                <el-table-column prop="userName" label="用户名"></el-table-column>
                <el-table-column
                  prop="accessTime"
                  label="操作时间"
                ></el-table-column>
                <el-table-column
                  prop="ipaddr"
                  label="登录IP"
                ></el-table-column>
                <el-table-column prop="msg" label="操作"></el-table-column>
                <!-- <el-table-column
                  prop="details"
                  label="操作详情"
                ></el-table-column> -->
              </el-table>
            </div>
          </div>
        </zj-layout-main>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
          ></el-pagination>
        </zj-layout-footer>
      </zj-layout-container>
    </div>
  </template>
  
  <script>
  import { loginLog } from "@/api/system/permission/log";
  export default {
    name: "LoginLogview",
    controller: "UI",
    action: "LoginLogview",
    props: {
      fullPath: String,
      path: String,
      query: Object,
      hash: String,
      targetUrl: String,
      targetUri: Object,
      menu: Object,
    },
    data() {
      return {
        // 遮罩层
        loading: false,
        // 总条数
        total: 0,
        // 日历时间
        dateRange: null,
        // 查询参数
        queryParams: {
          userName: null,
        //   operationIp: null,
          startTime: null,
          endTime: null,
          pageNum: 1,
          pageSize: 10,
        },
        // 区域数据
        regionData: [],
        // 表格数据
        operationLogList: [],
        // Status: 0,
        title: "登录登出日志",
      };
    },
    created() {
      this.getList();
    },
    methods: {
      // 查询
      getList() {
        this.loading = true;
        this.queryParams.startTime =
        this.dateRange != null ? this.dateRange[0] : null;
        this.queryParams.endTime =
        this.dateRange != null ? this.dateRange[1] : null;
        this.queryParams.status = this.Status;
        loginLog(this.queryParams).then((response) => {
            // console.log("response")
            // console.log(response)
          this.operationLogList = response.rows;
          this.total = Number(response.total);
          this.loading = false;
        });
      },
      // 点击查询按钮
      onSearch() {
        this.queryParams.pageNum = 1;
        this.getList();
      },
      // 点击清理按钮
      onCancel() {
        this.resetForm("queryForm");
        this.dateRange = null;
        this.onSearch();
      },
      // 点击每页显示的条数
      handleSizeChange(val) {
        this.queryParams.pageSize = val;
        this.getList();
      },
      // 点击切换到某页
      handleCurrentChange(val) {
        this.queryParams.pageNum = val;
        this.getList();
      },
    },
  };
  </script>
  <style scoped>
  ::v-deep .el-form-item {
    vertical-align: top;
  }
  </style>
  